var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoOfUnits = function SvgNoOfUnits(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#no_of_units_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCAA1",
    d: "M12.881 6.355H7.234v4.942h5.647zM28.764 6.355h-5.647v4.942h5.647zM12.881 16.945H7.234v4.942h5.647zM28.764 16.945h-5.647v4.942h5.647zM12.881 27.531H7.234v4.941h5.647zM28.764 27.531h-5.647v4.941h5.647z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M35.293.707H.705v2.824h34.588zM35.293 11.297H.705v2.823h34.588zM35.293 21.883H.705v2.823h34.588z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M35.293 32.473H.705v2.823h34.588zM18 3.531H2.117v7.765H18zM33.882 3.531H18v7.765h15.882zM18 14.117H2.117v7.765H18zM33.882 14.117H18v7.765h15.882zM18 24.707H2.117v7.765H18zM33.882 24.707H18v7.765h15.882z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "no_of_units_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
};
export default SvgNoOfUnits;